import React, { useContext } from 'react'
import styled from 'styled-components'
import FormatCurrency from 'components/Common/FormatCurrency'
import LinePlaneFlyIcon from 'components/Luxkit/Icons/line/LinePlaneFlyIcon'
import useDefaultAirport from 'hooks/useDefaultAirport'
import Caption from 'components/Luxkit/Typography/Caption'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { isDepositAvailableOnOffer, isDepositEnabledForOfferType } from 'lib/payment/depositsUtils'
import CurrencyContext from 'contexts/currencyContext'
import SecureWithDepositTagAndTooltip from 'components/Common/SecureWithDeposit/SecureWithDepositTagAndTooltip'
import CaptionTextBlock from 'components/Luxkit/TextBlocks/CaptionTextBlock'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'

const Pricing = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQueryUp.desktop} {
    align-items: center;
  }
`

interface Props {
  offer: App.Offer | App.OfferSummary;
}

function FrontPageTileFlightOnlyPricing(props: Props) {
  const { offer } = props
  const defaultAirport = useDefaultAirport()
  const currentCurrency = useContext(CurrencyContext)

  const flightPrice = offer.flightPrices[defaultAirport?.code]

  if (!flightPrice) {
    return (
      <Pricing>
        <CaptionTextBlock variant="medium" weight="bold" startIcon={<LinePlaneFlyIcon />}>
          Hotel + Flights packages
        </CaptionTextBlock>
      </Pricing>
    )
  }

  // const flightCacheOn = !offer.flightCacheDisabled && flightPrice
  const totalPrice = (offer.lowestPricePackage?.price ?? 0) + flightPrice
  const totalValue = (offer.lowestPricePackage?.value ?? 0) + flightPrice
  const showValue = offer.lowestPricePackage?.shouldDisplayValue && totalValue > totalPrice

  const showSecureWithDepositTag = isDepositEnabledForOfferType(offer.type) &&
    isDepositAvailableOnOffer(offer, currentCurrency, null, (offer.lowestPricePackage?.price ?? 0))

  return (
    <Pricing>
      { showSecureWithDepositTag && <SecureWithDepositTagAndTooltip offerType={offer.type} /> }
      <CaptionTextBlock variant="medium" weight="bold" startIcon={<LinePlaneFlyIcon />}>
        Hotel + Flights
      </CaptionTextBlock>
      <Caption variant="medium" colour="neutral-three">{offer.tileDurationLabel} from</Caption>
      <PriceRowPriceCaption>{offer.tileDurationLabel} from</PriceRowPriceCaption>
      <PriceRowPrice
        data-testid="search-price"
        size="L"
        price={Math.ceil(totalPrice)}
        saleUnit="package"
        taxesAndFees={offer.lowestPricePackage?.taxesAndFees ?? 'inclusive'}
      />
      <Caption variant="medium" colour="neutral-three">2 adults</Caption>
      {showValue && <Caption variant="medium" weight="bold">
        Valued up to <FormatCurrency value={(offer.lowestPricePackage?.value ?? 0) + flightPrice} />
      </Caption>}
    </Pricing>
  )
}

export default FrontPageTileFlightOnlyPricing
